import type { Menus } from '../constants';

export const flatSubMenus = (menu: Menus[]) => {
  const result: Menus[] = [];

  const flatten = (items: Menus[] = []): void => {
    for (const item of items) {
      result.push(item);
      if (item.subMenus && item.subMenus.length > 0) {
        flatten(item.subMenus);
      }
    }
  };

  flatten(menu);
  return result;
};
